import iconLogo from "@/assets/icon-logo.webp?w=40;80&format=webp&quality=90&as=srcset";
import logo from "@/assets/logo.webp";
import { AppStoreButton, GooglePlayWhiteButton } from "@/components/store-buttons";
import useScrollAnimation from "@/hooks/use-scroll-animation";
import { DOWNLOAD_LINK } from "@/lib/constants";
import { useLocation } from "react-router";

const HERO_ROUTES = new Set(["/", "/waitlist"]);

function Nav() {
  const { pathname } = useLocation();
  const hasHero = HERO_ROUTES.has(pathname);
  const scrolledPastHero = useScrollAnimation("hero-logo", pathname);
  const isVisible = !hasHero || scrolledPastHero;

  return (
    <nav
      className={`nav backdrop-blur-sm transition-all duration-300 ${
        isVisible ? "opacity-100" : "pointer-events-none opacity-0"
      }`}
    >
      <a
        href={hasHero ? "#" : "/"}
        className="nav__logo  mx-0 justify-start"
      >
        <picture>
          <source
            media="(max-width: 639px)"
            srcSet={iconLogo}
            sizes="32px"
          />
          <img src={logo} alt="Sakeena Logo" className="w-8 sm:w-32 md:w-32" />
        </picture>
      </a>

       <div className="flex gap-2 sm:hidden">
        <GooglePlayWhiteButton
          variant="icon"
          href={DOWNLOAD_LINK.PLAY_STORE_LINK}
        />
        <AppStoreButton variant="icon" href={DOWNLOAD_LINK.APP_STORE_LINK} />
      </div> 
    </nav>
  );
}

export default Nav;
